import Icon from '@components/Icon';
import { ButtonHTMLAttributes } from 'react';

import styles from './styles.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    fullWidth?: boolean;
    variant?: 'primary' | 'secondary' | 'outline' |'sub' | 'sub-outline' | 'tertiary';
    size?: 'sm' | 'md' | 'lg';
    leftIcon?: string;
    color?: string;
    backgroundColor?: string;
}

function Button(props: Props) {
  const {
    fullWidth, variant, children, size, leftIcon, color, backgroundColor, className, ...rest
  } = props;
  return (<button
        className={`${styles.button}
                    ${styles[`button-${variant}`]}
                    ${styles[`button-${fullWidth ? 'full' : 'auto'}`]}
                    ${styles[`button-${size}`]}
                    ${className}
                    `}
        style={{ color, backgroundColor }}
        {...rest} >
        {children}
        {leftIcon && (
            <Icon name={leftIcon}
                  className={styles.leftIcon}/>
        )}
    </button>);
}

export default Button;
